import {mapGetters, mapActions} from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'userExams',
      'userSchoolOverides',
      'userEvaluations',
      'totalPaShadowingHours',
      'certificationsInfo',
      'totalCommunityServiceHours',
      'totalVolunteerHours',
      'totalIndirectHours',
      'totalDirectHours',
      'totalDirectPaidHours',
      'overallCaspaGpa',
      'scienceCaspaGpa',
      'nonscienceCaspaGpa',
      'overallGpa',
      'scienceGpa',
      'nonscienceGpa',
      'userColleges',
      'user']
    ),
    allowedUserColleges () {
      return this.userColleges.filter(({ college_type, degree }) =>  {
        if (college_type == '2 Year' && !this.allowsCommunityCollege) return false
        return true
      })
    },
    currentScroolUserOverides () {
      return this.userSchoolOverides[this.savedSchool.id] ? Object.values(this.userSchoolOverides[this.savedSchool.id]) : []
    },
    checkUserLoggedIn () {
      if(this.user !== undefined && this.user !== null) {
        return true
      } else return false
    },
    checkUserIsSubscribed () {
      if(this.user.subscriptions) {
        let id= Object.keys(this.user.subscriptions)[0];
        let subscriptionStatus = this.user.subscriptions[id].subscription.status
          if(subscriptionStatus === 'active') {
            return true
          } else return false
      } else return false
    }
  },
  methods: {
    ...mapActions(['saveSchoolOveride', 'removeSchoolOveride']),
    hasOverideForCourse (data, type = null) {
      if (type === null) return false
      let targetId = null

      if (type === 'category') {
        targetId = data.category.id
      }

      if (type === 'course') {
        targetId = data.id
      }

      if (type === 'optionalcourse') {
        targetId = this.getIDForOptionalGroup(data)
      }

      return this.currentScroolUserOverides.find(({ id }) => targetId === id)
    },
    getIDForOptionalGroup (data) {
      return data.options.map(({ id }) => id).join('-')
    },
    async forceValidateCourse (data, type = null, add = true) {
      if (this.busy || !type || !this.savedSchool.id) return null
      const payload = {
        schoolId: this.savedSchool.id,
        type
      }

      this.busy = true

      if (type === 'category') {
        payload['id'] = data.category.id
      }

      if (type === 'course') {
        payload['id'] = data.id
      }

      if (type === 'optionalcourse') {
        payload['id'] = this.getIDForOptionalGroup(data)
      }

      if (!add && this.userSchoolOverides[this.savedSchool.id]) {
        for (const key in this.userSchoolOverides[this.savedSchool.id]) {
          const element = this.userSchoolOverides[this.savedSchool.id][key];
          if (element.id === payload.id) {
            await this.removeSchoolOveride({ schoolId: this.savedSchool.id, id: key })
            this.busy = false
            break
          }
        }
        return null
      }
      await this.saveSchoolOveride(payload)
      this.busy = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/usersmixin.js